import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TabsContext } from '@/components/Tabs';
import ButtonBase from '@/components/ButtonBase';
import cx from '@/utils/cx';
import useStyle from './style';

const TabLabel = ({
  contentId,
  children,
  className,
  selectedProps,
  ...rest
}) => {
  const { onChange, _color, value } = useContext(TabsContext);
  const classes = useStyle({ _color });
  const isSelected = value === contentId;

  return (
    <ButtonBase
      _size="md"
      className={cx(classes.tabLabel, isSelected && !selectedProps && 'selected', selectedProps && selectedProps.className, className)}
      {...(isSelected ? { 'data-selected': '', ...selectedProps } : {})}
      aria-selected={isSelected}
      onClick={() => onChange(contentId)}
      {...rest}
    >
      {children}
    </ButtonBase>
  );
};

TabLabel.propTypes = {
  contentId: PropTypes.string.isRequired,
  selectedProps: PropTypes.object,
};

TabLabel.defaultProps = {
  selectedProps: null,
};


export default TabLabel;
